import without from 'lodash/without'

export default function (attribute) {
  return function (event) {
    var value = attribute.value || []
    var checkboxValue = +event.target.value

    if (value.includes(checkboxValue)) {
      attribute.onChange(without(value, checkboxValue))
    } else {
      attribute.onChange([...value, checkboxValue])
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/collection-change-handler.js